import { render, staticRenderFns } from "./KfDialog.vue?vue&type=template&id=2caad464&"
import script from "./KfDialog.vue?vue&type=script&lang=js&"
export * from "./KfDialog.vue?vue&type=script&lang=js&"
import style0 from "./KfDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports